module.exports = __webpack_public_path__ + "static/GT-Super-Text-Bold-Italic-c99726617e6e9fb4db4404a2d894c5cf.woff2";